
import i18n from '@/i18n'
import { Component, Vue } from 'vue-property-decorator'
import ScriptLoader from '@/utils/ScriptLoader'
import { NavigationGuardNext, Route } from 'vue-router'
import TeaserAccountTile from '@/components/tile/TeaserAccountTile.vue'

@Component({
  i18n,
  components: {
    TeaserAccountTile
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.ACCOUNT_MANAGEMENT).catch((_reason) =>
        Promise.resolve()
      )
    ])
      .then(() => next())
      .catch((_reason) => next())
  },
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.ACCOUNT_MANAGEMENT).catch((_reason) =>
        Promise.resolve()
      )
    ])
      .then(() => next())
      .catch((_reason) => next())
  }
})
export default class UsernameRetrievalPage extends Vue {}
